document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('[data-adm-product-full-data]');

  sections.forEach((section) => {
    const tabs = Array.from(section.querySelectorAll('[data-adm-full-data-tab]'));
    const panels = Array.from(section.querySelectorAll('[data-adm-full-data-panel]'));
    const select = section.querySelector('[data-adm-full-data-select]');

    if (!tabs.length || !panels.length) return;

    const activateTab = (target) => {
      tabs.forEach((tab) => {
        const isActive = tab.dataset.admFullDataTab === target;

        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      panels.forEach((panel) => {
        const isActive = panel.dataset.admFullDataPanel === target;

        panel.classList.toggle('is-active', isActive);
      });

      if (select && select.value !== target) {
        select.value = target;
      }
    };

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        activateTab(tab.dataset.admFullDataTab);
      });
    });

    if (select) {
      select.addEventListener('change', () => {
        activateTab(select.value);
      });
    }

    activateTab('description');
  });

  const mediaGalleries = document.querySelectorAll('[data-adm-media-gallery]');

  mediaGalleries.forEach((gallery) => {
    const triggers = Array.from(gallery.querySelectorAll('[data-adm-media-trigger]'));
    const viewer = gallery.querySelector('[data-adm-media-viewer]');

    if (!triggers.length || !viewer) return;

    const setActiveMedia = (trigger) => {
      const type = trigger.dataset.mediaType;
      const src = trigger.dataset.mediaSrc;
      const alt = trigger.dataset.mediaAlt || '';

      triggers.forEach((item) => {
        item.classList.toggle('is-active', item === trigger);
      });

      if (type === 'image') {
        viewer.innerHTML = `
          <img
            src="${src}"
            alt="${alt}"
            width="1200"
            height="800"
            loading="lazy"
          >
        `;
      }

      if (type === 'youtube') {
        viewer.innerHTML = `
          <iframe
            src="${src}"
            title="${alt}"
            loading="lazy"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowfullscreen
          ></iframe>
        `;
      }
    };

    triggers.forEach((trigger) => {
      trigger.addEventListener('click', () => {
        setActiveMedia(trigger);
      });
    });
  });
});